<template>
  <div class="NotFoundView container pt-104">
    <div class="flex flex-col text-center align-center w-half ma-auto">
      <h1 class="font-family-display font-weight-bold mb-48">
        {{ $t('page_not_found') }} 😿
      </h1>
      <div class="w-half ma-auto">
        <router-link v-if="isAuth" to="/" class="btn btn--purple">
          {{ $t('home') }}
        </router-link>
        <router-link v-else :to="{ name: 'Login' }" class="btn btn--purple">
          {{ $t('login') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/authStore'
import { storeToRefs } from 'pinia'

const authStore = useAuthStore()
const { isAuth } = storeToRefs(authStore)
</script>
